import baseTheme from "@theme-ui/preset-base/src/index"

const heading = {
  color: 'text',
  fontFamily: 'heading',
  lineHeight: 'heading',
  fontWeight: 'heading',
}

const theme = {
  ...baseTheme,
  colors: {
    // ...baseTheme.colors,
    text: "#112D4E",
    background: "#F9F7F7",
    primary: "#3F72AF",
    heading: '#3F72AF',
    secondary: '#DBE2EF',
    muted: '#f6f6f6',
    // modes: {
    //   dark: {
    //     text: "#eeeeee",
    //     background: "#222831",
    //     primary: "#00ADB5",
    //     heading: '#00ADB5',
    //     secondary: '#393E46',
    //   }
    // }
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fonts: {
    body: "Merriweather, Georgia, serif",
    heading: "Montserrat, sans-serif",
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },
  styles: {
    root: {
      height: `100%`,
      minHeight: `100%`,
      body: {
        height: `100%`,
        minHeight: `100%`,
        m: 0
      },
      '#___gatsby': {
        height: `100%`,
      },
      '#gatsby-focus-wrapper': {
        height: `100%`,
      }
    },
    p: {
        lineHeight: 'body',
        fontSize: 2,
    },
    ul: {
      my: 0,
      fontSize: 2,
    },
    li: {
      mb: `calc(1.75rem / 2)`,
    },
    a: {
        color: 'heading'
    },
    h1: {
      fontSize: 6,
      fontFamily: 'heading',
      fontWeight: 'heading',
      mt: 4,
      mb: 4,
    },
    h2: {
      ...heading,
      mt: 4,
      fontSize: 5,
    },
    h3: {
      ...heading,
      fontSize: 4,
    },
  },
}

export default theme;